module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDAiIGhlaWdodD0iMjU0IiB2aWV3Qm94PSIwIDAgNTQwIDI1NCI+PHJlY3Qgd2lkdGg9IjUzOSIgaGVpZ2h0PSIyNTMuMTA1IiB4PSIxMTkuMzI3IiB5PSI1NjgwIiBmaWxsPSIjQ0NGN0ZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE5IC01NjgwKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/training-bg.svg
// module id = nH+4
// module chunks = 0